(() => {
  const BODY_CLASS = 'gh-search-usf-open';
  let scheduled = false;

  const setVar = (name, value) => {
    if (document.body.style.getPropertyValue(name) !== value) {
      document.body.style.setProperty(name, value);
    }
  };

  const rupee = (el) => {
    if (!el || el.dataset.ghRupee === el.textContent) return;
    const next = el.textContent.replace(/Rs\.?\s*/gi, '₹');
    if (next !== el.textContent) el.textContent = next;
    el.dataset.ghRupee = el.textContent;
  };

  const amount = (el) => Number((el?.textContent || '').replace(/[^\d]/g, '')) || 0;

  const polishProduct = (product) => {
    product.querySelectorAll('.usf-price, .usf-discount').forEach(rupee);

    if (product.querySelector('.gh-usf-off')) return;

    const compare = product.querySelector('.usf-price.usf-has-discount');
    const sale = product.querySelector('.usf-discount');
    if (!compare || !sale) return;

    const compareAmount = amount(compare);
    const saleAmount = amount(sale);
    if (!compareAmount || !saleAmount || saleAmount >= compareAmount) return;

    const off = document.createElement('span');
    off.className = 'gh-usf-off';
    off.textContent = `${Math.round((1 - saleAmount / compareAmount) * 100)}% OFF`;
    product.querySelector('.usf-price-wrapper')?.appendChild(off);
  };

  const placePopup = () => {
    const drawer = document.querySelector('.gh-search-drawer[aria-expanded="true"]');
    const popup = document.querySelector('.usf-popup.usf-is.usf-is--compact:not(.usf-hide)');

    if (!drawer) {
      document.body.classList.remove(BODY_CLASS);
      return;
    }

    // The USF popup is added asynchronously after the drawer opens. Mark the
    // drawer active first so its initial render cannot flash unstyled.
    document.body.classList.add(BODY_CLASS);

    if (!popup) return;

    const form = drawer.querySelector('.gh-search form');
    const bar = drawer.querySelector('.search--bar-wrapper');
    if (!form || !bar) return;

    const formRect = form.getBoundingClientRect();
    const barRect = bar.getBoundingClientRect();
    const gap = parseFloat(getComputedStyle(form).rowGap) || 18;

    setVar('--gh-usf-left', `${Math.round(formRect.left)}px`);
    setVar('--gh-usf-width', `${Math.round(formRect.width)}px`);
    setVar('--gh-usf-top', `${Math.round(barRect.bottom + gap)}px`);

    popup.querySelectorAll('.usf-is-product').forEach(polishProduct);
  };

  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      placePopup();
    });
  };

  const start = () => {
    const observer = new MutationObserver(schedule);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'aria-expanded'],
    });
    window.addEventListener('resize', schedule);
    document.addEventListener('scroll', schedule, true);
    schedule();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
